import { defaultAggProps } from "./index60.js";
import { isLineOnEdges } from "./index61.js";
function getSiteBoundaryWeightMod({ siteEdges, siteBoundaryFactor = defaultAggProps.siteBoundaryFactor }) {
	return (lines) => {
		const weights = lines.map((line) => getLineWeight(line, siteEdges, siteBoundaryFactor));
		if (weights.every((w) => w === 0)) return Array(lines.length).fill(1);
		return weights;
	};
}
function getLineWeight(line, siteEdges, siteBoundaryFactor) {
	if (isLineOnEdges(line, siteEdges)) return 1;
	return 1 - siteBoundaryFactor;
}
export { getSiteBoundaryWeightMod };

//# sourceMappingURL=index65.js.map